import { createReducer } from "@reduxjs/toolkit";
import { User } from "../../entities/user";
import { arrayToMap } from "../../helpers";

import {
  deleteUserSuccess,
  getUserByIdSuccess,
  getUsersSearchMetadataSuccess,
  getUsersSuccess,
  setUserFilters,
  setUserLoading,
  setUserSearchOpen,
  setSelectedUserID,
  setStagedUser,
  updateStagedUser,
  setUserFormOpen,
} from "./userActions";
import { UserState } from "./userState";

function initState(): UserState {
  return {
    users: {},
    searchOpen: false,
    searchMetadata: undefined,
    loading: false,
    stagedUser: undefined,
    selectedUserID: undefined,
    userFormOpen: false,
  };
}

export const userReducer = createReducer(initState(), (builder) => {
  builder.addCase(setUserLoading, (state, action) => {
    state.loading = action.payload.loading;
    return state;
  });
  builder.addCase(setUserFormOpen, (state, action) => {
    state.userFormOpen = action.payload.open;
    return state;
  });
  builder.addCase(setStagedUser, (state, action) => {
    state.stagedUser = action.payload.stagedUser;
    return state;
  });
  builder.addCase(setUserFilters, (state, action) => {
    state.filters = action.payload.filters;
    return state;
  });
  builder.addCase(setUserSearchOpen, (state, action) => {
    state.searchOpen = action.payload.searchOpen;
    return state;
  });
  builder.addCase(updateStagedUser, (state, action) => {
    if (!state.stagedUser) return state;
    state.stagedUser = {
      ...state.stagedUser,
      ...action.payload.stagedUser,
    };
    return state;
  });
  builder.addCase(setSelectedUserID, (state, action) => {
    state.selectedUserID = action.payload.userID;
    return state;
  });
  builder.addCase(getUsersSuccess, (state, action) => {
    const users = action.payload.users;
    state.users = arrayToMap<User>(users);
    return state;
  });
  builder.addCase(getUsersSearchMetadataSuccess, (state, action) => {
    state.searchMetadata = action.payload.usersSearchMetadata;
    return state;
  });
  builder.addCase(deleteUserSuccess, (state, action) => {
    const userID = action.payload.userID;
    if (state.users[userID]) {
      delete state.users[userID];
    }
    return state;
  });
  builder.addCase(getUserByIdSuccess, (state, action) => {
    const user = action.payload.user;
    if (user) {
      const users = { ...state.users };
      users[user.id] = user;
      state.users = users;
    }
    return state;
  });
});
